import React, { PureComponent } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { withSizes } from 'react-sizes';
import { withTranslation } from 'react-i18next';

import { reactiveTemplateConfigSelector } from 'common/selectors/theme';

import { setToObject } from 'common/utils';
import { BANNERS_TYPE_CATEGORY } from 'common/constants/SiteConstants';
import { getMapSizesToPropsCustom } from 'common/utils';
import { fetchBanners } from 'common/actions/PageActions';
import { getPageDataSelector, getPageSelector } from 'common/selectors/page';

import loadable from '@loadable/component';
const CategoryHeaderVariant = loadable(props =>
  import(`common/blocks/category/header/${props.blockVariant}`)
);

class CategoryHeader extends PureComponent {
  componentDidMount() {
    const { data, fetchCategoryBanners, activeRouteName } = this.props;
    if (!data) {
      return;
    }
    const { urlName } = data;
    if (urlName) {
      fetchCategoryBanners(urlName);
    }
  }
  render() {
    const {
      t,
      theme,
      title,
      blockSettings,
      data,
      meta,
      banners,
      isMD
    } = this.props;
    return (
      <CategoryHeaderVariant
        t={t}
        title={title}
        blockVariant={_.get(blockSettings, 'blockVariant')}
        categoryData={data}
        metaData={meta}
        banners={banners}
        theme={theme}
        isMD={isMD}
      />
    );
  }
}

let blockSettings = {};
const makeMapStateToProps = () => {
  const getPage = getPageSelector();
  const getPageData = getPageDataSelector();
  const reactiveTemplateConfig = reactiveTemplateConfigSelector(
    'CategoryHeaderVariant'
  );
  return (state, props) => {
    const pageData = getPageData(state, props);
    const page = getPage(state, props);
    return {
      data: _.get(pageData, 'data'),
      meta: _.get(page, 'meta'),
      banners: _.get(pageData, 'banners'),
      blockSettings: setToObject(blockSettings, {
        blockVariant: reactiveTemplateConfig(state, props)
      })
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCategoryBanners: categoryId => {
      dispatch(fetchBanners(BANNERS_TYPE_CATEGORY, categoryId));
    }
  };
};

const CategoryHeaderConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(CategoryHeader);

export default withTranslation()(withTheme(
  withSizes(getMapSizesToPropsCustom())(CategoryHeaderConnected))
);
